import axios from 'axios';
import router from '../../../router'
import store from '../../../store';
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);

export function request(url, method = "get", data = {}, config = {}) {
  return axiosRequest(url, method, data, config)
}

function axiosRequest(url, method, data, config) {

  if (method.toLowerCase() === 'post') {
    if (data instanceof Object) {
      let params = new URLSearchParams();
      for (let key in data) {
        params.append(key, data[key]);
      }
      data = params;
    }
  } else if (method.toLowerCase() === 'file') {
    method = "post";
    if (data instanceof Object) {
      let params = new FormData();
      for (let key in data) {
        params.append(key, data[key]);
      }
      data = params;
    }
  }

  let axiosConfig = {
    url: url,
    method: method.toLowerCase(),
    data: data
  };
  if (config instanceof Object) {
    for (let key in config) {
      axiosConfig[key] = config[key];
    }
  }

  let service = axios.create();

  // //拦截器
  // service.interceptors.request.use(function (config) {

  //     if (config.method==='post'){

  //         // config.data = qs.stringify(config.data);
  //         config.data = config.data;

  //     }else if (config.method==='file'){
  //         config.method="post";
  //         if (config.data && config.data instanceof Object){
  //             let params=new FormData();
  //             for (let key in config.data){
  //                 params.append(key, config.data[key]);
  //             }
  //             config.data=params;
  //         }
  //     }

  //     return config;
  // }, function (error) {
  //     return Promise.reject(error);
  // });



  //响应之后
  service.interceptors.response.use(function (response) {
    // console.log('response');
    // console.log(response);        
    if (response.data.user) {

      // response.data.user 如果是空数组[]，就不复值

      if (response.data.user instanceof Array) { } else {

        let userInfo = response.data.user;
        localStorage["userInfo"] = JSON.stringify(userInfo);
        localStorage["guid"] = userInfo.guid;
        localStorage["security"] = userInfo.security;
        localStorage["isLogin"] = true;
        store.commit("user/SET_USER_INFO", { userInfo: userInfo });
        
      }

    }

    if (response.data.status === -99 || response.data.status === -11) {

      localStorage.removeItem("userInfo");
      localStorage.removeItem("guid");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("security");
      // store.commit("user/OUT_LOGIN");
      store.dispatch("user/outLogin", {
        success: (res) => {
          router.push('/login');
        }
      });

    }

    // if (response.config.url===response.config.baseURL+"/home/user/safe?token=1ec949a15fb709370f"){
    //     if (response.config.data.code!==200){
    //         // window.location.href = "http://www.lucklnk.com"
    //     }
    // }
    
    return response;
  }, function (error) {

    Toast.clear();
    Toast('error');
    console.log(error)
    return Promise.reject(error);
  });


  return service.request(axiosConfig).then(res => res.data);

}